import { useQuery } from '@tanstack/react-query';

/**
 * Simple hook to format targeting profile IDs for display
 * 
 * @param targetingProfileIds Array of targeting profile IDs (which are AdGroup IDs)
 * @param enabled Whether the query should execute
 * @returns Query result with formatted AdGroup data for display
 */
export function useAdGroupsByIds(targetingProfileIds: string[], enabled = true) {
  return useQuery({
    queryKey: ['adGroupsByIds', targetingProfileIds],
    queryFn: () => {
      if (!targetingProfileIds || targetingProfileIds.length === 0) {
        return { adGroups: [] };
      }
      
      // Since targeting_profiles IDs are the AdGroup IDs, we just need to format them for display
      const adGroups = targetingProfileIds.map(id => ({
        id: parseInt(id, 10),
        name: `AdGroup ${id}`
      }));
      
      return { adGroups };
    },
    enabled: enabled && targetingProfileIds.length > 0
  });
}

export default useAdGroupsByIds;